import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ContactComponent } from '../contact/contact';
import { PricingComponent } from '../pricing/pricing';

@Component({
  selector: 'app-home',

  templateUrl: './home.html',
  imports: [NgOptimizedImage, RouterModule, ButtonModule, ContactComponent, PricingComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {}
